import { call, put } from "redux-saga/effects";

import { api, notify } from "services";
import { ICreateRequest } from "interfaces/create-duck";
import { requestErrorHandler } from "utils";
import { CreateBlockDateActions } from "store/ducks/settings/block-dates";

export function* createBlockDateRequest(action: any) {
  try {
    const { postData, onSuccess } = action as ICreateRequest;

    const { data: responseBody } = yield call(
      api.post,
      `/block-dates`,
      postData
    );

    const { data } = responseBody;
    yield put(CreateBlockDateActions.success(data));
    notify("success", "Horário cadastrado com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(CreateBlockDateActions.failure(errorMessage));
  }
}
